import { render, staticRenderFns } from "./SelectionUpdate.vue?vue&type=template&id=c6d22634&scoped=true&"
import script from "./SelectionUpdate.vue?vue&type=script&lang=js&"
export * from "./SelectionUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d22634",
  null
  
)

export default component.exports